import { Button, DialogActions, DialogTitle } from "@mui/material";
import GTextField from "../../libs/textfield/GTextField";
import { useRef } from "react";
import FormGroup from "../../libs/form/FormGroup";
import FormControl from "../../libs/form/FormControl";
import Validators from "../../libs/form/Validators";
import PassApi from "../../data/PassApi";
import { useDialog } from "../../libs/dialog/DialogProvider";
import { useSnackbar } from "../../libs/dialog/SnackbarProvider";

export default function NewPassword(){
    const {closeDialog} = useDialog()
    const {setSnackbar} = useSnackbar()
    const name = useRef<any>("")
    const form = new FormGroup("new", [new FormControl("Name", [Validators.Required])])
    const onCreate = async () => {
        if (!form.dirty) form.markAllAsDirty()
        if (!form.valid) return

        try {
            await PassApi.i.create(name.current.value)
            closeDialog()
        }catch(e){
            setSnackbar(e)
        }
    }
    return <>
        <DialogTitle>New Password</DialogTitle>
        <div className="content">
            <GTextField placeholder="Name" inputRef={name} form={form} controlName="Name"/>
        </div>
        <DialogActions>
            <Button color="primary" onClick={onCreate}>Create</Button>
        </DialogActions>
    </>
}